<ng-container *ngIf="products$ | async as products; else loader">
  @if (listTitle) {
    <h3 class="font-heading-4 pr-xsmall-y font-title-medium" data-testid="product-list-title">
      {{ listTitle }}
    </h3>
  }
  <div
    class="product-list"
    [class.product-list--tablet-two-per-row]="tabletShowTwoPerRow"
    [class.product-list--new-layout]="useNewProductCardLayout"
  >
    <ng-container *ngFor="let product of products; let index = index">
      <fcom-product-card
        [hasAddedItems]="(product.count$ | async) !== 0"
        [loading]="(product.status$ | async) === ButtonState.UPDATING"
        [title]="product.title"
        [detailText]="product.description | finStripHtml | finEmpty: ''"
        [showDetailText]="product.isBundle"
        [image]="product.image"
        [lowQuota]="product.lowQuota$ | async"
        [lowestPrice]="product.lowestPrice | finNonZeroAmount: hideZeroPrices | finPrice | finEmpty: ''"
        [originalPrice]="product.originalPrice | finNonZeroAmount: hideZeroPrices | finPrice | finEmpty: ''"
        [aviosPrice]="product.points$ | async"
        [aviosLowestPrice]="product.lowestPriceAsPoints?.amount | finPoints | finEmpty: ''"
        [price]="product.price$ | async | finNonZeroAmount: hideZeroPrices | finPrice | finEmpty: ''"
        [statusText]="
          ((product.purchasedCount$ | async) === 0 || (product.purchasedCount$ | async) > 0) &&
          (product.count$ | async) === 0
            ? ''
            : (product.count$ | async) === 0
              ? (productCardLocalizationsPrefix + 'services.' + product.category + '.state.selection.default'
                | finLocalization)
              : (product.count$ | async) === 1
                ? (productCardLocalizationsPrefix + 'services.' + product.category + '.state.selection.singular'
                  | finLocalization)
                : (productCardLocalizationsPrefix + 'services.' + product.category + '.state.selection.plural'
                  | finLocalization: { numberOfItems: product.count$ | async })
        "
        [purchasedText]="
          (product.purchasedCount$ | async) === 0
            ? (productCardLocalizationsPrefix + 'services.' + product.category + '.state.purchased.default'
              | finLocalization)
            : (product.purchasedCount$ | async) === 1
              ? (productCardLocalizationsPrefix + 'services.' + product.category + '.state.purchased.singular'
                | finLocalization)
              : (product.purchasedCount$ | async) > 1
                ? (productCardLocalizationsPrefix + 'services.' + product.category + '.state.purchased.plural'
                  | finLocalization: { numberOfItems: product.purchasedCount$ | async })
                : ''
        "
        [viewSummaryText]="'services.productCards.viewSummary' | finLocalization"
        [buttonIcon]="useNewProductCardLayout ? SvgLibraryIcon.ARROW_RIGHT : SvgLibraryIcon.PLUS"
        [buttonText]="
          (useNewProductCardLayout && (product.count$ | async) > 0
            ? 'ancillaries.productCard.button.modify'
            : useNewProductCardLayout
              ? 'ancillaries.productCard.button.select'
              : (product.status$ | async) === ButtonState.OK
                ? 'services.' + product.category + '.state.modify.text'
                : 'services.' + product.category + '.state.select.text'
          ) | finLocalization
        "
        [buttonAriaText]="
          ((product.status$ | async) === ButtonState.OK
            ? 'services.' + product.category + '.state.modify.ariaText'
            : (product.status$ | async) === ButtonState.UPDATING
              ? 'services.' + product.category + '.state.updating.ariaText'
              : 'services.' + product.category + '.state.select.ariaText'
          ) | finLocalization
        "
        [buttonTheme]="
          (product.status$ | async) === ButtonState.OK
            ? ButtonTheme.LIGHT_SECONDARY_OUTLINE
            : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
        "
        [hideButton]="
          (product.category !== Category.SEAT && product.maxPurchasesDone$ | async) === true ||
          (product.notAvailable$ | async) === true ||
          (product.noQuotaLeft && (product.count$ | async) === 0) ||
          product.notEligibleWithIncompatibleSeat === true
        "
        (selectProduct)="onSelectProduct(product.category, index)"
        [focusOnBtn]="(focusOnProductBtn$ | async) === product.category"
        [attr.data-testid]="'service-selection-' + product.category"
        [notificationTheme]="(product.productCardNotification$ | async)?.theme"
        [notificationIcon]="(product.productCardNotification$ | async)?.icon"
        [notificationText]="(product.productCardNotification$ | async)?.messageKey | finLocalization"
        [notificationTitle]="(product.productCardNotification$ | async)?.titleKey | finLocalization"
        [productTags]="product.productTags"
        [showStackableLabels]="showStackableLabels"
        [useNewProductCardLayout]="useNewProductCardLayout"
        [countText]="
          useNewProductCardLayout && (product.count$ | async) > 0
            ? ('ancillaries.productCard.added' | finLocalization: { numberOfItems: product.count$ | async })
            : ''
        "
        [isLaptopUp]="isLaptopUp$ | async"
      />
    </ng-container>
  </div>
</ng-container>

<ng-template #loader>
  <div class="align-center fill">
    <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" />
  </div>
</ng-template>
